/* Sydney Mirrors — Header V2 predictive search
   Drops a results panel under the top bar search field as the visitor types,
   from Shopify's Predictive Search API (routes.predictive_search_url, the
   same source as Shopify's own search drawer): suggested searches, products
   with image and price, collections and pages, then a "Search for" link to
   the full results page.

   The form carries:
     data-hd2-suggest-url   routes.predictive_search_url
     data-hd2-money-format  shop.money_format, e.g. ${{amount}}
   and holds the [data-hd2-suggest] panel. Opening and closing the field itself
   stays in the section's inline script; this only manages the panel. */
(function () {
  var MIN_CHARS = 2;
  var DELAY = 200;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* The API returns prices as "1299.00" in shop currency. Shopify's own
     money formats use {{amount}} (1,299.00) or {{amount_no_decimals}}. */
  function money(value, format) {
    var n = Number(value);
    if (isNaN(n)) return '';
    var fixed = n.toFixed(2).split('.');
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    format = format || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + fixed[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + fixed[1])
      .replace(/<[^>]*>/g, '');
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function init(form) {
    if (form.dataset.hd2SuggestInit) return;
    form.dataset.hd2SuggestInit = 'true';

    var input = form.querySelector('[data-hd2-search-input]');
    var panel = form.querySelector('[data-hd2-suggest]');
    var url = form.dataset.hd2SuggestUrl;
    var format = form.dataset.hd2MoneyFormat;
    if (!input || !panel || !url) return;

    var timer = null;
    var controller = null;
    var current = '';

    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    function hide() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      current = '';
    }

    function show(html) {
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function group(title, items) {
      if (!items) return '';
      return '<div class="hd2__suggest-group"><p class="hd2__suggest-title">' + esc(title) + '</p><ul class="hd2__suggest-list" role="list">' + items + '</ul></div>';
    }

    function render(q, r) {
      var queries = (r.queries || []).map(function (s) {
        return '<li><a class="hd2__suggest-query" href="' + esc(s.url) + '">' + (s.styled_text || esc(s.text)) + '</a></li>';
      }).join('');

      var products = (r.products || []).map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var varies = Number(p.price_max) > Number(p.price_min);
        var sale = Number(p.compare_at_price_max) > Number(p.price);
        var price = (varies ? '<span class="hd2__suggest-from">From</span> ' : '') +
          '<span class="' + (sale ? 'hd2__suggest-sale' : '') + '">' + esc(money(p.price, format)) + '</span>' +
          (sale ? ' <s>' + esc(money(p.compare_at_price_max, format)) + '</s>' : '');
        return '<li><a class="hd2__suggest-product" href="' + esc(p.url) + '">' +
          '<span class="hd2__suggest-thumb">' + (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '<span class="hd2__suggest-info"><span class="hd2__suggest-name">' + esc(p.title) + '</span>' +
          '<span class="hd2__suggest-price">' + price + '</span></span></a></li>';
      }).join('');

      var collections = (r.collections || []).map(function (c) {
        return '<li><a class="hd2__suggest-link" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
      }).join('');

      var pages = (r.pages || []).map(function (p) {
        return '<li><a class="hd2__suggest-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></li>';
      }).join('');

      var body = group('Suggestions', queries) + group('Products', products) +
        group('Collections', collections) + group('Pages', pages);

      if (!body) {
        body = '<p class="hd2__suggest-empty">No results for “' + esc(q) + '”.</p>';
      }

      var all = form.getAttribute('action') + '?q=' + encodeURIComponent(q);
      show(body + '<a class="hd2__suggest-all" href="' + esc(all) + '">Search for “' + esc(q) + '”' +
        '<svg width="13" height="10" viewBox="0 0 15 12" fill="none" aria-hidden="true"><path d="M1 6h12M8.6 1.4 13.2 6l-4.6 4.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></a>');
    }

    function run() {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { hide(); return; }
      if (q === current && !panel.hidden) return;
      current = q;

      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      var params = 'q=' + encodeURIComponent(q) +
        '&resources[type]=query,product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url + '.json?' + params, controller ? { signal: controller.signal } : {})
        .then(function (res) { return res.json(); })
        .then(function (data) {
          // Ignore a reply that arrives after the visitor has typed on.
          if (input.value.trim() !== q) return;
          render(q, (data.resources && data.resources.results) || {});
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, DELAY);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && panel.hidden) run();
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });

    // Pressing a result keeps focus in the field, so the blur below never
    // fires mid-click (Safari does not focus links on click, which otherwise
    // closed the panel before the click landed).
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });

    // Close when focus or a click leaves the form; links inside it stay usable.
    form.addEventListener('focusout', function (e) {
      if (!form.contains(e.relatedTarget)) hide();
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });

    // The section clears the field when it closes; follow it.
    new MutationObserver(function () {
      if (!form.classList.contains('hd2__search--open')) hide();
    }).observe(form, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    document.querySelectorAll('[data-hd2-suggest-url]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
